const SummaryErrorTile = () => {
    return (
        <div className="flex mx-4 mb-4 rounded-xl bg-[#FFBABA] p-5 items-center">
            <div className="text-[#D8000C] ml-3">Submit fail! There is an error, please try again.</div>
        </div>
    )
}

export default SummaryErrorTile;
